import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Axios from 'axios';
import { debounce, get } from 'lodash';
import { API_HOST } from '../../consts';
import RelatorioTurmaColumn from '../../components/RelatorioTurmaColumn';
import ComplexBarChart from '../relatorio/ComplexBarChart';
import { toast } from 'react-toastify';
import { GeneralStudentStyleButton } from './style';
import { ThemeContext } from 'styled-components';
import { CircularProgress, Container } from '@material-ui/core';
import Swal from 'sweetalert2';
import ReportGraphEssay from '../relatorio/ReportGraphEssay';
import StackedBarChart from './StackedBarChart';
import TableEssayGrades from '../../components/Table/TableEssayGrades';
import BasicBarChart from '../relatorio/BasicBarChart';
import FilterRelatorio from './FilterRelatorio';
import { Grid } from '@material-ui/core';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';
import GeneralStudentSkillReport from './GeneralStudentSkillReport';
import GeneralClassReport from './GeneralClassReport';
import Loading from '../../components/Loading';


const ReportClass = ({ match }) => {
  const [relatorioTurma, setRelatorioTurma] = useState();
  const titulo = [
    'Linguagens, Códigos e suas Tecnologias',
    'Matemática e suas Tecnologias',
    'Ciências da Natureza e suas Tecnologias',
    'Ciências Humanas e suas Tecnologias'
  ];
  const [AnoData, setAnoData] = useState();
  const [PeriodoData, setPeriodoData] = useState();
  const [downloading, setDownloading] = useState(false);
  const [statusCSV, setStatusCSV] = useState();
  const [fileKey, setFileKey] = useState();
  const [lastGeneratedDate, setLastGeneratedDate] = useState();
  const [graphRedacaoBar, setGraphRedacaoBar] = useState();
  const [graphRedacaoCompetencia, setGraphRedacaoCompetencia] = useState();
  const [graphRedacaoCompetenciaPie, setGraphRedacaoCompetenciaPie] = useState();
  const [tableEssayData, setTableEssayData] = useState([]);
  const [basicBarChart, setBasicBarChart] = useState([]);
  const [filter, setFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const cd_turma = filtrosRelatorios && filtrosRelatorios.cd_turma;
  const ano = filtrosRelatorios && filtrosRelatorios.periodoAno;
  const theme = useContext(ThemeContext);
  const { filtrosRelatorios, setStateFilters } = useContext(FilterRelatorioContext)

  const fetchAnoData = async () => {
    Axios.get(`${API_HOST}/avalia/ano?id=${1}`)
      .then((res) => {
        setAnoData(res.data);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (filtrosRelatorios.isFormSubmit === true) {
      buttonRelatorio();
      setStateFilters({ isFormSubmit: false })
    }
  }, [filtrosRelatorios.isFormSubmit])

  const fetchPeriodo = async () => {
    try {
      const resPeriodo = await Axios.get(`${API_HOST}/avalia/periodo?id=${filtrosRelatorios.periodo}`);
      setPeriodoData(resPeriodo.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchRelatorioTurma = async () => {
    setIsLoading(true)
    try {
      fetchAnoData();
      fetchPeriodo();
      const resTurma = await Axios.get(`${API_HOST}/avalia/boletim_mt/student_list?CD_ESCOLA=${filtrosRelatorios.currentEscola}&CD_TURMA=${filtrosRelatorios.cd_turma}&CD_DISCIPLINA=${filtrosRelatorios.DisciplinaID}&PERIODO_ANO_ID__id=${filtrosRelatorios.periodoAno}&NR_ETAPA=${filtrosRelatorios.nrEtapa}`);
      if (resTurma.data.length === 0) {
        throw new Error('Não existem dados para a consulta realizada');
      }
      setStateFilters({ fecth: true });
      setRelatorioTurma(resTurma.data);
    } catch (err) {
      toast.error(err.message);
      setStateFilters({ fecth: false, fecthRelatorioHabilidade: false, fecthRelatorioGeral: false });
    }
    setIsLoading(false)
  };

  function sleep(delay = 0) {
    return new Promise((resolve) => {
      setTimeout(resolve, delay);
    });
  }

  const fetchStatusMicrodados = async (id) => {
    await sleep(5e3);

    const params = { id: id };
    await Axios.get(`${API_HOST}/avalia/microdados/get_microdados_status`, {
      params
    })
      .then((res) => {
        if (res.data.file_key) {
          const link = document.createElement('a');
          link.href = res.data.file_key;

          link.download = 'microdados.csv';

          link.click();

          setDownloading(false);
          fetchLastMicrodados();
        } else {
          fetchStatusMicrodados(id);
          setDownloading(true);
        }
      })
      .catch((err) => toast.error(err));
  };

  const handleDownloadCSV = () => {
    const dataISO = lastGeneratedDate;
    let formatBr = 'Arquivo não gerado';
    if (dataISO) {
      const data = new Date(dataISO);
      const options = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      };

      formatBr = data.toLocaleDateString('pt-BR', options);
    }
    if (!downloading) {
      Swal.fire({
        title: `Data da última geração: ${formatBr}`,
        showCancelButton: dataISO ? true : false,
        confirmButtonText: dataISO ? 'Gerar Novamente' : 'Gerar',
        cancelButtonText: 'Baixar Anterior',
        showConfirmButton: statusCSV === 4 ? true : false
      }).then((result) => {
        if (result.isConfirmed) {
          get_microdados_csv();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          const link = document.createElement('a');
          link.href = fileKey;
          link.download = 'microdados.csv';
          link.click();
        }
      });
    }
  };

  const fetchLastMicrodados = () => {
    Axios.get(`${API_HOST}/avalia/microdados/get_last_generated?cd_turma=${filtrosRelatorios.cd_turma}&periodo_ano_id=${filtrosRelatorios.periodoAno}`)
      .then((response) => {
        if (response.data && response.data.res) {
          setLastGeneratedDate(response.data.res.criado_em);
          setFileKey(response.data.res.file_key);
          setStatusCSV(response.data.status);
          setStateFilters({ fecth: true })
        } else {
          throw new Error('Não existem dados para a consulta realizada');
        }
      })
      .catch((err) => {
        toast.error('Não existem fetchLastMicrodados para a consulta realizada');
        setStateFilters({ fecth: false, fecthRelatorioHabilidade: false, fecthRelatorioGeral: false });
      });
  };

  const get_microdados_csv = debounce(() => {
    setDownloading(true);
    const payload = {
      cd_turma: cd_turma,
      periodo_ano_id: ano,
      etapa: match.params.nr_etapa,
    };
    Axios.post(`${API_HOST}/avalia/microdados/get_microdados_csv`, { payload })
      .then((res) => {
        fetchStatusMicrodados(res.data);
      })
      .catch((err) => toast.error(err));
  }, 1000);

  const fetchGraphEssayBar = async () => {
    try {
      const params = {
        tipo: 'redacao-turma-bar',
        escola: filtrosRelatorios.currentEscola,
        disciplina: filtrosRelatorios.DisciplinaID,
        ano: filtrosRelatorios.periodoAno,
        turma: filtrosRelatorios.cd_turma,
        etapa: filtrosRelatorios.nrEtapa
      };
      const res = await Axios.get(
        `${API_HOST}/avalia/estudante/get_notas_to_line_chart`,
        { params }
      );
      setGraphRedacaoBar(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchGraphEssayCompetenciaBar = async () => {
    try {
      const params = {
        tipo: 'redacao-turma-stacked',
        escola: filtrosRelatorios.currentEscola,
        disciplina: filtrosRelatorios.DisciplinaID,
        ano: filtrosRelatorios.periodoAno,
        turma: filtrosRelatorios.cd_turma,
        etapa: filtrosRelatorios.nrEtapa
      };
      const res = await Axios.get(
        `${API_HOST}/avalia/estudante/get_stacked_area_graph`,
        { params }
      );
      setGraphRedacaoCompetencia(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const buttonRelatorio = async () => {
    if (filtrosRelatorios.fecth === true) {
      setFilter(!filter);
    }
    setStateFilters({ fecth: false });
    await fetchLastMicrodados();
    await fetchRelatorioTurma();
    if (filtrosRelatorios && filtrosRelatorios.DisciplinaID == 8) {
      await fetchGraphEssayBar();
      await fetchGraphEssayCompetenciaBar();
      await fetchNotasRedacaoAlunos();
      await fetchNotasRedacaoAlunosPie();
      await fetchBasicBarChart();
    }
    setStateFilters({ fecthRelatorioGeral: false, fecthRelatorioHabilidade: false });
  }

  const fetchNotasRedacaoAlunosPie = async () => {
    try {
      const params = {
        tipo: 'redacao-turma-pie',
        escola: filtrosRelatorios.currentEscola,
        disciplina: filtrosRelatorios.DisciplinaID,
        ano: filtrosRelatorios.periodoAno,
        turma: filtrosRelatorios.cd_turma,
        etapa: filtrosRelatorios.nrEtapa
      };
      const res = await Axios.get(
        `${API_HOST}/avalia/estudante/get_stacked_area_graph`,
        { params }
      );
      setGraphRedacaoCompetenciaPie(res.data);
    } catch (error) {
      console.error(error);
    }
  }

  const fetchNotasRedacaoAlunos = async () => {
    try {
      const params = {
        tipo: 'redacao-turma-table',
        escola: filtrosRelatorios.currentEscola,
        disciplina: filtrosRelatorios.DisciplinaID,
        ano: filtrosRelatorios.periodoAno,
        turma: filtrosRelatorios.cd_turma,
        etapa: filtrosRelatorios.nrEtapa
      };
      const res = await Axios.get(`${API_HOST}/avalia/estudante/get_notas_to_line_chart`, { params })
      setTableEssayData(res.data);
    } catch (error) {
      console.error(error);
    }
  }

  const fetchBasicBarChart = async () => {
    try {
      const params = {
        tipo: 'dre-comparativo-media-dn-dr-escola-turma',
        escola: filtrosRelatorios.escolaId,
        disciplina: filtrosRelatorios.DisciplinaID,
        periodoAnoId: filtrosRelatorios.periodoAno,
        turma: filtrosRelatorios.cd_turma,
      };
      const res = await Axios.get(`${API_HOST}/avalia/estudante/get_notas_to_chart`, { params })
      setBasicBarChart(res.data);
    } catch (error) {
      console.error(error);
    }
  }
  const redeOrdn = 'REDE, DRE';

  return (
    <Container style={{ width: 'fit-content', background: '#fff' }} maxWidth="lg">
      <div
        style={{
          marginTop: '3rem',
          // background: '#fff',
          // maxWidth: '1110px',
          borderRadius: '16px'
          // boxShadow: '0px 1px 5px rgba(58, 58, 58, 0.25)'
        }}
      >
        <div style={{ marginTop: '3rem', }}>
          <div className="container mb-4 pb-4">
            <div className="row">
              <div className="col-12">
                <div
                  className="card"
                  style={{ backgroundColor: '#f7f7f7', borderRadius: '10px' }}
                >
                  <div
                    className="card-header"
                    style={{
                      marginBottom: '-0.7rem',
                      backgroundColor: '#f7f7f7',
                      borderRadius: '10px'
                    }}
                  >
                    <h1
                      style={{
                        fontFamily: 'Quicksand',
                        fontSize: '24px',
                        color: '#292929',
                        fontWeight: 'bold'
                      }}
                    >
                      Relatório de Turmas
                    </h1>
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#292929',
                        fontWeight: 500,
                        fontFamily: 'Quicksand'
                      }}
                    >
                      Proficiência dos estudantes
                    </span>

                    <hr
                      style={{
                        background: '#bebebe',
                        width: '100%',
                        height: '1px',
                        borderRadius: '1px'
                      }}
                    />
                  </div>

                  <div className="card-body">
                    <Grid item xs={12} style={{ marginTop: '1rem' }}>
                      <FilterRelatorio
                        buttonRelatorio={buttonRelatorio}
                      />
                    </Grid>
                    <div style={{ background: '#bebebe', width: '100%', height: '1px', marginTop: '1rem' }} />
                    <div>
                      {isLoading && (
                        <div>
                          <Loading />
                        </div>)}

                      {
                        filtrosRelatorios.fecth && (
                          <>
                            {isLoading ? (
                              <div>
                                <Loading />
                              </div>) : (
                              <div>
                                {filtrosRelatorios.DisciplinaID == 8 ? (
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      width: '100%'
                                    }}
                                  >
                                    {basicBarChart && (
                                      <div className="mt-2" style={{ width: '100%' }}>
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: `${theme.primary}`,
                                            borderTopLeftRadius: '10px',
                                            borderTopRightRadius: '10px',
                                          }}
                                        >
                                          <div
                                            className="basic__info"
                                            style={{
                                              padding: '0.3rem',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                            }}
                                          >
                                            <label
                                              style={{
                                                color: 'white',
                                                marginTop: '0.5rem',
                                                fontWeight: 600,
                                                textAlign: 'center',
                                                fontSize: '16px',
                                                textTransform: 'uppercase',
                                                marginRight: "60px",
                                              }}
                                            >
                                              Gráfico comparativo {redeOrdn}, Escola e Turma
                                            </label>
                                          </div>
                                        </div>
                                        <BasicBarChart
                                          data={basicBarChart}
                                          title={''}
                                        />
                                      </div>
                                    )
                                    }

                                    <div className="mt-2" style={{ width: '100%' }}>
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          background: `${theme.primary}`,
                                          borderTopLeftRadius: '10px',
                                          borderTopRightRadius: '10px'
                                        }}
                                      >
                                        <div
                                          className="basic__info"
                                          style={{
                                            padding: '0.3rem',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                          }}
                                        >
                                          <label
                                            style={{
                                              color: 'white',
                                              marginTop: '0.5rem',
                                              fontWeight: 600,
                                              textAlign: 'center',
                                              fontSize: '16px',
                                              textTransform: 'uppercase',
                                              marginRight: '60px'
                                            }}
                                          >
                                            Gráfico Nota por Competência
                                          </label>
                                        </div>
                                      </div>
                                      <StackedBarChart
                                        dados={
                                          graphRedacaoCompetencia
                                            ? graphRedacaoCompetencia.data
                                            : ''
                                        }
                                        media={true}
                                        tituloCompleto={''}
                                      />
                                      <StackedBarChart
                                        dados={
                                          graphRedacaoCompetencia
                                            ? graphRedacaoCompetencia.data
                                            : ''
                                        }
                                        tituloCompleto={''}
                                      />
                                      {/* NAO APAGAR! ESSE TRECHO DEVE SER MANTIDO PARA FACILITAR ALTERACOES FUTURAS PELO SESI. */}
                                      {/* <CompetenciasPieCharts
                                        data={graphRedacaoCompetenciaPie}
                                      /> */}
                                    </div>

                                    <div className="mt-2" style={{ width: '100%' }}>
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          background: `${theme.primary}`,
                                          borderTopLeftRadius: '10px',
                                          borderTopRightRadius: '10px'
                                        }}
                                      >
                                        <div
                                          className="basic__info"
                                          style={{
                                            padding: '0.3rem',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                          }}
                                        >
                                          <label
                                            style={{
                                              color: 'white',
                                              marginTop: '0.5rem',
                                              fontWeight: 600,
                                              textAlign: 'center',
                                              fontSize: '16px',
                                              textTransform: 'uppercase',
                                              marginRight: '60px'
                                            }}
                                          >
                                            Gráfico Alunos por Notas
                                          </label>
                                        </div>
                                      </div>
                                      <ReportGraphEssay
                                        data={graphRedacaoBar ? graphRedacaoBar : ''}
                                        title={''}
                                        type={'column'}
                                      />
                                      <TableEssayGrades data={tableEssayData} />
                                    </div>
                                  </div>
                                ) : (
                                  <>
                                    <div>
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'flex-end',
                                          padding: '16px 40px',
                                          marginTop: '20px',
                                          width: '100%',
                                          backgroundColor: `${theme.primary}10`,
                                          borderRadius: '20px'
                                        }}
                                      >
                                        <button
                                          disabled={downloading}
                                          style={{
                                            backgroundColor: theme.primary,
                                            padding: '10px 20px',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '20px',
                                            width: '250px'
                                          }}
                                          onClick={() => handleDownloadCSV()}
                                        >
                                          {downloading ? (
                                            <>
                                              <CircularProgress
                                                size={16}
                                                style={{
                                                  color: '#fff'
                                                }}
                                              />
                                            </>
                                          ) : (
                                            <>
                                              <i
                                                className="fas fa-download"
                                                style={{
                                                  width: '18px',
                                                  height: '16px',
                                                  fontSize: '24px',
                                                  fontWeight: 900,
                                                  zIndex: '1',
                                                  marginRight: '20px',
                                                  marginTop: '-16px'
                                                }}
                                              />
                                              <span
                                                style={{
                                                  fontSize: '15px',
                                                  fontFamily: 'Quicksand',
                                                  fontWeight: 500
                                                }}
                                              >
                                                Baixar microdados CSV
                                              </span>
                                            </>
                                          )}
                                        </button>
                                      </div>
                                      <div>
                                        <div
                                          className="input-type-style"
                                          style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            marginLeft: '4rem',
                                            flexDirection: 'column'
                                          }}
                                        >
                                          <ComplexBarChart
                                            tituloCompleto={
                                              'Desempenho médio da turma por área do conhecimento'
                                            }
                                            tipo={'turma'}
                                            escola={filtrosRelatorios.currentEscola}
                                            turma={filtrosRelatorios.cd_turma}
                                            etapa={filtrosRelatorios.nrEtapa}
                                            ano={filtrosRelatorios.periodoAno}
                                            disciplina={filtrosRelatorios.DisciplinaID}
                                            update={filter}
                                          />
                                        </div>

                                        <div>
                                          <h1
                                            style={{
                                              fontWeight: 'bold',
                                              color: `${(props) => props.theme.primary}`
                                            }}
                                          >
                                            {
                                              titulo[
                                              relatorioTurma
                                                ? get(relatorioTurma[0], 'CD_DISCIPLINA') - 1
                                                : ''
                                              ]
                                            }
                                          </h1>
                                        </div>
                                        {isLoading ? (
                                          <div>
                                            isLoading
                                            <Loading />
                                          </div>
                                        ) : (
                                          <RelatorioTurmaColumn
                                            disciplina={
                                              titulo[
                                              relatorioTurma
                                                ? get(relatorioTurma, '[0].CD_DISCIPLINA') - 1
                                                : ''
                                              ]
                                            }
                                            prova={PeriodoData}
                                            relatorios={relatorioTurma}
                                            periodo={filtrosRelatorios.periodoAno}
                                            tituloCompleto="Nível de Proficiência do Estudante por Turma"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                          </>
                        )
                      }
                      {filtrosRelatorios.fecthRelatorioHabilidade && (
                        <GeneralStudentSkillReport />
                      )}
                      {filtrosRelatorios.fecthRelatorioGeral && (
                        <GeneralClassReport />
                      )}
                      {(filtrosRelatorios.fecth ||
                        filtrosRelatorios.fecthRelatorioHabilidade ||
                        filtrosRelatorios.fecthRelatorioGeral
                      ) && (
                          <GeneralStudentStyleButton>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                width: '100%',
                                padding: "2rem 6rem 1rem 6rem",
                              }}
                            >
                              <button
                                style={{
                                  width: '200px',
                                  border: 'none',
                                  fontSize: '1rem',
                                  fontWeight: '600',
                                  cursor: 'pointer',
                                  borderRadius: '20px',
                                  boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                  padding: '4px 16px',
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  marginLeft: '1rem',
                                  color: theme.textButton,
                                  background: theme.secondary
                                }}
                                onClick={() => {
                                  setStateFilters({
                                    fecth: true,
                                    fecthRelatorioHabilidade: false,
                                    fecthRelatorioGeral: false
                                  })
                                }}
                              >
                                Relatório de Turmas
                              </button>
                              {filtrosRelatorios.DisciplinaID != 8 && (
                                <>
                                  <button
                                    style={{
                                      border: 'none',
                                      fontSize: '1rem',
                                      fontWeight: '600',
                                      cursor: 'pointer',
                                      borderRadius: '20px',
                                      boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                      padding: '4px 16px',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginLeft: '1rem',
                                      color: theme.textButton,
                                      background: theme.secondary
                                    }}
                                    onClick={() => {
                                      setStateFilters({
                                        fecthRelatorioHabilidade: true,
                                        fecthRelatorioGeral: false,
                                        fecth: false
                                      })
                                    }}
                                  >
                                    Relatório de estudante por habilildade
                                  </button>
                                  <button
                                    className="button-primary"
                                    style={{
                                      border: 'none',
                                      fontSize: '1rem',
                                      fontWeight: '600',
                                      cursor: 'pointer',
                                      borderRadius: '20px',
                                      boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                                      padding: '4px 16px',
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginLeft: '1rem'
                                    }}
                                    onClick={() => {
                                      setStateFilters({
                                        fecthRelatorioGeral: true,
                                        fecthRelatorioHabilidade: false,
                                        fecth: false
                                      })
                                    }}
                                  >
                                    Visão Geral da Turma
                                  </button>
                                </>
                              )}
                            </div>
                          </GeneralStudentStyleButton>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default withRouter(ReportClass);
